import { MetricBelowFilterQueryParams } from "@CommonTypes/merchflow/pog/pogMetrics";

export const RoutePutMerchflows_MerchflowId_StoresApprovals =
  "/merchflows/:merchflowId/stores/approvals";

export interface Approval {
  store_pog_id: number;
}

/** The All Stores list's own filters: approve-all acts on exactly the stores the list shows. */
export type StoreApprovalFilters = MetricBelowFilterQueryParams & {
  store_pog_trigger_id?: number;
  storeCode?: string;
};

export type PayloadPutMerchflows_MerchflowId_StoresApprovals =
  | { approved: Approval[] }
  | { unapproved: Approval[] }
  | { approveAllExclude: Approval[]; filters?: StoreApprovalFilters }
  | { unapproveAllExclude: Approval[]; filters?: StoreApprovalFilters };
